<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="10"
        offset-md="1"
      >
        <v-sheet
          class="pa-8"
          tile
          min-height="500"
        >
          <h2 class="display-1 primary--text mb-2 long-title-wrap">
            {{ $t('manual.title') }}
          </h2>
          <div class="resp-container">
            <iframe
              :src="`${publicPath}assets/docs/Geoportal2.pdf`"
              class="pdf-manual"
            />
          </div>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
// TODO plik pdf powinien brać nazwę/ścieżkę z API
export default {
  name: 'Public',
  components: {
  },
  data: () => ({
    publicPath: process.env.BASE_URL
  })
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  .pdf-manual
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    border: 0
  .resp-container
    position: relative
    overflow: hidden
    padding-top: 56.25%

</style>
